module.exports = __webpack_public_path__ + "img/logo-inovis.6ade8c59.png";